import { AxiosResponse } from "axios";
import API from "../api";
import { CompanySubDomain } from "../models/company.subdomain";
import { SubDomainInfo } from "../types";
import BaseService from "./_base.service";

const endpoint = "company-subdomain";

const CompanySubDomainService = {
  ...BaseService<CompanySubDomain>({ endpoint }),
  async getBy(subdomain: string): Promise<AxiosResponse<SubDomainInfo>> {
    return await API.get(`/${endpoint}/get/by`, { params: { subdomain } });
  },
};

export default CompanySubDomainService;
